export const queuedApprovalText='האישור בתור · יבוצע אוטומטית'
export const ownerActions=new Set(['decision_approve','decision_reverse','approve_fix_and_message','approve_fix','approve_message','reply_approve','approve_direction','edit_direction','approve','retry','reply_retry'])
export class ActionFailure extends Error {constructor(message:string,public retryable=false){super(message)}}
export type PendingApproval={key:string;owner:string;action:string;payload:Record<string,unknown>;created:number;next:number;attempt:number;error?:string;failed?:boolean}
type StorageLike=Pick<Storage,'getItem'|'setItem'>
export class ApprovalOutbox {
 private running=false
 private listeners=new Set<()=>void>()
 private waiters=new Map<string,{resolve:(v:unknown)=>void;reject:(e:Error)=>void}>()
 readonly storageKey='command-owner-outbox-v1'
 constructor(private storage:StorageLike,private execute:(entry:PendingApproval)=>Promise<unknown>,private now=()=>Date.now(),private sleep=(ms:number)=>new Promise<void>(resolve=>setTimeout(resolve,ms))){}
 entries():PendingApproval[]{try{const v=JSON.parse(this.storage.getItem(this.storageKey)||'[]');return Array.isArray(v)?v:[]}catch{throw new Error('לא הצלחנו לקרוא את האישורים השמורים. אין לשלוח שוב לפני בדיקה')}}
 subscribe=(fn:()=>void)=>{this.listeners.add(fn);return()=>{this.listeners.delete(fn)}}
 private save(rows:PendingApproval[]){this.storage.setItem(this.storageKey,JSON.stringify(rows));this.listeners.forEach(fn=>fn())}
 async submit(owner:string,action:string,payload:Record<string,unknown>){
  const key=owner+':'+String(payload.message_id)+':'+action
  const rows=this.entries(),existing=rows.find(e=>e.key===key)
  if(existing?.failed)throw new Error(existing.error)
  if(!existing)this.save([...rows,{key,owner,action,payload,created:this.now(),next:this.now(),attempt:0}])
  return new Promise((resolve,reject)=>{this.waiters.set(key,{resolve,reject});void this.flush(owner)})
 }
 async flush(owner:string){
  if(this.running)return
  this.running=true
  try{let processed=0;for(const original of this.entries().filter(e=>e.owner===owner&&!e.failed&&e.next<=this.now())){
   if(processed++)await this.sleep(150)
   let entry={...original}
   try{
    if(this.now()-entry.created>=600000)throw new ActionFailure('עברו עשר דקות. האישור לא בוצע; בדוק את המצב ונסה שוב')
    const result=await this.execute(entry)
    this.save(this.entries().filter(e=>e.key!==entry.key));this.waiters.get(entry.key)?.resolve(result);this.waiters.delete(entry.key)
   }catch(error){
    const retryable=error instanceof ActionFailure&&error.retryable
    entry={...entry,attempt:entry.attempt+1}
    if(retryable&&this.now()-entry.created<600000){entry.next=Math.min(entry.created+600000,this.now()+[2000,5000,15000,60000][Math.min(entry.attempt-1,3)])}
    else{entry.failed=true;entry.error=(error as Error).message;this.waiters.get(entry.key)?.reject(error as Error);this.waiters.delete(entry.key)}
    this.save(this.entries().map(e=>e.key===entry.key?entry:e))
   }
  }}finally{this.running=false}
 }
}
